import { MapGroupId } from "../../types";
import img from "../../mapImages/Terminal2D.webp";

const mapData = {
  groupId: MapGroupId.Terminal,
  groupName: {
    en: "Terminal",
    ru: "Терминал",
  },
  title: {
    en: "Main",
    ru: "Главная",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
